module.exports = __webpack_public_path__ + "img/down4-zh.86d7ca29.png";